import React, { Component, useEffect } from "react";
import "./Styles/Dist/Bootstrap/css/bootstrap.min.css";
import "./Styles/Dist/fonts/Druk/druk.css";
import "./Styles/Dist/fonts/Roboto/roboto.css";
import "./Styles/Dist/fonts/PT_Serif/PT_serif.css";
import "./Styles/Dist/fonts/Inter/Inter.css";
import { Api } from "./Components";
import { getMunicipalityData } from "./Components/Api/Api";

import axios from "axios";

import PageLayout from "./Components/Layout/PageLayout";

import smoothscroll from "smoothscroll-polyfill";

// kick off the polyfill for smoothscroll!
smoothscroll.polyfill();

const FILTER_POP_KINGDOM = "vs:RegionRiket99";
const FILTER_EjAggr = "EjAggr";
const FILTER_BARAEjAggr = "+BaraEjAggr";
const FILTER_MUNICIPALITY = "vs:RegionKommun07";
const SWEDEN_CODE = "00";

export class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requestedMunicipalities: Api.getRequestedMunicipalities(),
      landusedata: [],
      populationLocationdata: [],
      all_population_change_data: [],
      populationchangedata: [],
      populationdata: [],
      agedata: [],
      municipalityselection: [],
      montelyincomedata: [],
      sweden: {},
      landusedata: [],
      accommodationdata: [],
      genderdata: [],
      genderAgeData: [],
      birthplacedata: [],
      emplomentextentdata: [],
      livingconditiondata: [],
      taxratedata: [],
      electiondata: [],
      isLoadingData: false
    };
  }
  /* 13 anrop*/
  componentDidMount() {
    getMunicipalityData(SWEDEN_CODE, null, [SWEDEN_CODE]).then(
      municipalities_data => {
        this.setState({
          sweden: {
            population: municipalities_data[0].population[0],
            populationLocation: municipalities_data[0].populationLocation[0],
            populationChange: municipalities_data[0].populationChange[0],
            accommodation: municipalities_data[0].accommodation[0],
            gender: municipalities_data[0].gender[0],
            age: municipalities_data[0].genderAge[0],
            montelyincome: municipalities_data[0].income[0],
            landuse: municipalities_data[0].landUse[0],
            birthplace: municipalities_data[0].birthplace[0],
            emplomentextent: municipalities_data[0].emplomentExtent[0],
            livingcondition: municipalities_data[0].livingCondition[0],
            taxrate: municipalities_data[0].taxRate[0],
            election: municipalities_data[0].election[0]
          },
          isLoadingData: false
        });
      }
    );
  }

  datahandler = municipalities => {
    this.setState({ isLoadingData: true });
    if (municipalities.length > 1) {
      var municipalities1 =
        municipalities[0] != null ? municipalities[0] : null;
      var municipalities2 =
        municipalities[1] != null ? municipalities[1] : null;

      getMunicipalityData(municipalities1, municipalities2, municipalities)
        .then(municipalities_data => {
          this.setState({
            populationdata: municipalities_data[0].population,
            populationLocationdata: municipalities_data[0].populationLocation,
            populationchangedata: municipalities_data[0].populationChange,
            genderdata: municipalities_data[0].gender,
            genderAgeData: municipalities_data[0].genderAge,
            birthplacedata: municipalities_data[0].birthplace,
            landusedata: municipalities_data[0].landUse,
            montelyincomedata: municipalities_data[0].income,
            livingconditiondata: municipalities_data[0].livingCondition,
            taxratedata: municipalities_data[0].taxRate,
            electiondata: municipalities_data[0].election,
            accommodationdata: municipalities_data[0].accommodation,
            emplomentextentdata: municipalities_data[0].emplomentExtent,
            isLoadingData: false
          });
        })
        .catch(e => console.log(e));
    } else {
      console.log("en eller ingen");
    }
  };

  render() {
    return (
      <React.Fragment>
        <PageLayout data={this.state} datahandler={this.datahandler} />
      </React.Fragment>
    );
  }
}

export default App;
